import { Box } from "@mui/material";
import { styled as muiStyled } from '@mui/material/styles';
import { borderRadius, display, fontWeight, minWidth, width } from "@mui/system";
import { thirdly2 } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { bg } from "styles/theme";


export const ProfilesStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    // justifyContent: "space-between",
    columnGap: 20,
    padding: 20,
    boxSizing: "border-box",
    background: thirdly4,
    rowGap: 10,
    borderRadius: 15,
    flexGrow: 1,
    overflow: "auto",
    '.profile-cards': {
        display: "flex",
        flexDirection: "column",
        rowGap: 8,
        overflow: "auto"
    },
    '.ability-label': {
        fontWeight: "bold"
    },
    '.ability-group': {
        background: "#F5F9FF",
        // padding: 15
    },
    '.category-item': {
        background: "#EAF3FF",
        borderRadius: 16,
        padding: 10,
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        minWidth: 200,
        overflow: "auto",
        flexGrow: 1
    },
    '.categories': {
        display: "flex",
        columnGap: 10,
        overflow: "auto",
        flexGrow: 1
    },
    '.profile-title': {
        display: "flex",
        alignItems: "center",
        columnGap: 7
    },
    '.profile-content-card-item': {
        display: "flex"
    },
    '.profile-header': {
        padding: 10,
        boxSizing: "border-box",
        borderRadius: 12,
        background: bg,
        rowGap: 7,
        display: "flex",
        flexDirection: "column"
    },
    '.profile-content-card': {

    },
    '.profile-section': {
        flexGrow: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.profile-content-cards': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        background: "white",
        padding: 12,
        boxSizing: "border-box",
        borderRadius: 12,
        border: `1px solid ${bg}`
    },

}));

export const RatingListStyles = muiStyled(Box)(({ }) => ({
    width: 200,
    '.rating-legend': {
        width: "100%",
        background: thirdly4,
        border: `1px solid ${thirdly2}`,
        borderRadius: 16,
        padding: 20,
        boxSizing: "border-box",
        display: "flex",
        rowGap: 10,
        flexDirection: "column"
    },
    '.rating-items': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 5
    },
    '.rating-item': {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.title': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    }
}));


export const ProfilesPageStyles = muiStyled(Box)(({ }) => ({
    flexGrow: 1,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    columnGap: 15,
    overflow: "auto",
    '.description-header': {
        display: "flex",
        flexDirection: "column",
        rowGap: 5,
        height: 75,
        justifyContent: "center"
    },
    '.view-options-btns': {
        display: "flex",
        alignItems: "center",
        columnGap: 7
    },
    '.profiles-content': {
        overflow: "auto",
        display: "flex",
        columnGap: 15,
        height: "100%"
    },
    '.wrap-profiles-content': {
        overflow: "auto",
        background: "white",
        padding: 20,
        paddingTop: 0,
        borderRadius: 10,
        display: "flex",
        columnGap: 15,
        flexDirection: "column",
        rowGap: 20,
        height: "100%"
    },
    '.profiles-header': {

    },
    '.secondary-toolbar': {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        padding: "8px 0 0 0",
    },
    '.secondary-toolbar-text': {
        flex: 1,
        fontSize: 12,
        color: "#666",
        lineHeight: 1.5,
    }
}));